import store from "../store/store";

export const hoje = new Date();
export const mesAtual = hoje.getMonth() + 1;

export const primeiroDiaDoMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1)
  .toISOString()
  .split("T")[0];

export const ultimoDiaDoMes = new Date(
  hoje.getFullYear(),
  hoje.getMonth() + 1,
  0
)
  .toISOString()
  .split("T")[0];

export const meses = {
  1: "Janeiro",
  2: "Fevereiro",
  3: "Março",
  4: "Abril",
  5: "Maio",
  6: "Junho",
  7: "Julho",
  8: "Agosto",
  9: "Setembro",
  10: "Outubro",
  11: "Novembro",
  12: "Dezembro",
};

export const anos = () => {
  const state = store.getState();
  const session = state.session.session;

  const anoInicial =
    session && session?.inicio_prestacao ? session.inicio_prestacao : 2018;
  const hoje = new Date();
  const ano_que_vem = hoje.getFullYear() + 1;

  let anos = {};
  for (let i = ano_que_vem; i >= anoInicial; i--) {
    anos[i] = i;
  }
  return anos;
};

// Recebe YYYY-MM-DD
// Retorna DD/MM/YYYY
export const formataData = (data) => {
  try {
    const regexData = /^\d{4}-\d{2}-\d{2}$/;

    if (!regexData.test(data)) return "";

    const [ano, mes, dia] = data.split("-");

    const dataObj = new Date(data + "T00:00:00");
    if (
      dataObj.getFullYear() !== parseInt(ano) ||
      dataObj.getMonth() !== parseInt(mes) - 1 ||
      dataObj.getDate() !== parseInt(dia)
    ) {
      throw new Error("A data fornecida não é válida.");
    }

    const diaFormatado = String(dataObj.getDate()).padStart(2, "0");
    const mesFormatado = String(dataObj.getMonth() + 1).padStart(2, "0");
    const anoFormatado = dataObj.getFullYear();
    return `${diaFormatado}/${mesFormatado}/${anoFormatado}`;
  } catch (error) {
    console.error(error);
    return "";
  }
};

export const adicionarDias = (numeroDias, data = null) => {
  const dataNova = new Date(data ? data : hoje);
  dataNova.setDate(dataNova.getDate() + numeroDias);
  return dataNova.toISOString().split("T")[0];
};

export const subtrairDias = (numeroDias) => {
  const dataNova = new Date(hoje);
  dataNova.setDate(hoje.getDate() - numeroDias);
  return dataNova.toISOString().split("T")[0];
};

// Recebe YYYY-MM
// Retorna YYYY-MM-DD
export const getPrimeiroDia = (data) => {
  try {
    const regexData = /^\d{4}-\d{2}$/;

    if (!regexData.test(data)) {
      throw new Error(
        "A entrada para getPrimeiroDia deve estar no formato YYYY-MM."
      );
    }

    const [ano, mes] = data.split("-");

    if (parseInt(mes) < 1 || parseInt(mes) > 12) {
      throw new Error("O mês fornecido não é válido.");
    }

    const primeiroDia = new Date(`${ano}-${mes}-01T00:00:00`);
    const dia = String(primeiroDia.getDate()).padStart(2, "0");
    const mesFormatado = String(primeiroDia.getMonth() + 1).padStart(2, "0");
    const anoFormatado = primeiroDia.getFullYear();
    return `${anoFormatado}-${mesFormatado}-${dia}`;
  } catch (error) {
    console.error(error);
    return "";
  }
};

// Recebe YYYY-MM
// Retorna YYYY-MM-DD
export const getUltimoDia = (data) => {
  try {
    const regexData = /^\d{4}-\d{2}$/;

    if (!regexData.test(data)) {
      throw new Error(
        "A entrada para getPrimeiroDia deve estar no formato YYYY-MM."
      );
    }

    const [ano, mes] = data.split("-");

    if (parseInt(mes) < 1 || parseInt(mes) > 12) {
      throw new Error("O mês fornecido não é válido.");
    }

    const ultimoDia = new Date(new Date(ano, mes, 0).setHours(0, 0, 0, 0));
    const dia = String(ultimoDia.getDate()).padStart(2, "0");
    const mesFormatado = String(ultimoDia.getMonth() + 1).padStart(2, "0");
    const anoFormatado = ultimoDia.getFullYear();
    return `${anoFormatado}-${mesFormatado}-${dia}`;
  } catch (error) {
    console.error(error);
    return "";
  }
};

// Recebe YYYY-MM-DD
// Retorna MM/YYYY
export const formataDataMes = (data) => {
  try {
    const regexData = /^\d{4}-\d{2}-\d{2}$/;

    if (!regexData.test(data)) {
      throw new Error(
        "A entrada para getPrimeiroDia deve estar no formato YYYY-MM-DD."
      );
    }

    const [ano, mes, dia] = data.split("-");

    const dataObj = new Date(data + "T00:00:00");
    if (
      dataObj.getFullYear() !== parseInt(ano) ||
      dataObj.getMonth() !== parseInt(mes) - 1 ||
      dataObj.getDate() !== parseInt(dia)
    ) {
      throw new Error("A data fornecida não é válida.");
    }

    const mesFormatado = String(dataObj.getMonth() + 1).padStart(2, "0");
    const anoFormatado = dataObj.getFullYear();
    return `${mesFormatado}/${anoFormatado}`;
  } catch (error) {
    console.error(error);
    return "";
  }
};

export const getProximaDataUtil = (dia = null) => {
  var today = new Date();
  if (dia != null) today = new Date(dia);
  var nextBusinessDay = new Date(today);

  do {
    nextBusinessDay.setDate(nextBusinessDay.getDate());
  } while (!isDiaUtil(nextBusinessDay));

  var dd = nextBusinessDay.getDate();
  var mm = nextBusinessDay.getMonth() + 1;
  var yyyy = nextBusinessDay.getFullYear();

  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }

  return yyyy + "-" + mm + "-" + dd;
};

export const isDiaUtil = (date, inicio_ferias = false) => {
  date.setDate(date.getDate() + 1);
  var dayOfWeek = date.getDay(); // 0 (domingo) a 6 (sábado)

  var feriados = new Set([
    new Date(date.getFullYear(), 0, 1).toDateString(), // 1 de janeiro - Confraternização Universal
    new Date(date.getFullYear(), 3, 21).toDateString(), // 21 de abril - Dia de Tiradentes
    new Date(date.getFullYear(), 4, 1).toDateString(), // 1 de maio - Dia do Trabalhador
    new Date(date.getFullYear(), 8, 7).toDateString(), // 7 de setembro - Dia da Independência
    new Date(date.getFullYear(), 9, 12).toDateString(), // 12 de outubro - Nossa Senhora Aparecida
    new Date(date.getFullYear(), 10, 2).toDateString(), // 2 de novembro - Dia de Finados
    new Date(date.getFullYear(), 10, 15).toDateString(), // 15 de novembro - Proclamação da República
    new Date(date.getFullYear(), 11, 25).toDateString(), // 25 de dezembro - Natal
  ]);

  var preFeriados = new Set([
    new Date(date.getFullYear(), 11, 30).toDateString(), // 25 de dezembro - Confraternização Universal
    new Date(date.getFullYear(), 11, 31).toDateString(), // 25 de dezembro - Confraternização Universal
    new Date(date.getFullYear(), 3, 20).toDateString(), // 21 de abril - Dia de Tiradentes
    new Date(date.getFullYear(), 3, 19).toDateString(), // 21 de abril - Dia de Tiradentes
    new Date(date.getFullYear(), 3, 29).toDateString(), // 21 de abril - Dia do Trabalhador
    new Date(date.getFullYear(), 3, 30).toDateString(), // 21 de abril - Dia do Trabalhador
    new Date(date.getFullYear(), 8, 6).toDateString(), // 7 de setembro - Dia da Independência
    new Date(date.getFullYear(), 8, 5).toDateString(), // 7 de setembro - Dia da Independência
    new Date(date.getFullYear(), 9, 11).toDateString(), // 12 de outubro - Nossa Senhora Aparecida
    new Date(date.getFullYear(), 9, 10).toDateString(), // 12 de outubro - Nossa Senhora Aparecida
    new Date(date.getFullYear(), 9, 31).toDateString(), // 2 de novembro - Dia de Finados
    new Date(date.getFullYear(), 10, 1).toDateString(), // 2 de novembro - Dia de Finados
    new Date(date.getFullYear(), 10, 14).toDateString(), // 15 de novembro - Proclamação da República
    new Date(date.getFullYear(), 10, 13).toDateString(), // 15 de novembro - Proclamação da República
    new Date(date.getFullYear(), 11, 24).toDateString(), // 25 de dezembro - Natal
    new Date(date.getFullYear(), 11, 23).toDateString(), // 25 de dezembro - Natal
  ]);

  if (inicio_ferias)
    return (
      dayOfWeek >= 1 &&
      dayOfWeek <= 3 &&
      !feriados.has(date.toDateString()) &&
      !preFeriados.has(date.toDateString())
    );

  return dayOfWeek >= 1 && dayOfWeek <= 5 && !feriados.has(date.toDateString());
};

export const adicionarDiasUteis = (numeroDias, data = null) => {
  const result = new Date(data ? data : hoje);
  let count = 0;
  while (count < numeroDias - 1) {
    result.setDate(result.getDate() + 1);
    if (checaDiaUtil(result)) {
      count++;
    }
  }
  return result;
};

function checaDiaUtil(date) {
  const day = date.getDay();
  return day >= 1 && day <= 5;
}
